export enum Roles {
  None = 0,
  Teacher = 1,
  FacilityManager = 2,
  Admin = 4,
}
